import React from 'react';
import classNames from 'classnames';
import DiagnosticPackageStatusBar from '../DiagnosticPackageStatusBar';
import styles from './DiagnosticPackageTableHead.module.css';

function DiagnosticPackageTableHead({ diagPkgId, onComplete, onRetry, className, style, children }) {
  return (
    <div className={classNames(styles.root, 'rt-thead', className)} style={style}>
      {children}
      {diagPkgId && (
        <div className={classNames(styles.status, 'rt-tr')}>
          <DiagnosticPackageStatusBar key={diagPkgId} diagPkgId={diagPkgId} onComplete={onComplete} onRetry={onRetry} />
        </div>
      )}
    </div>
  );
}

export default DiagnosticPackageTableHead;
